import * as z from 'zod';

import { EscrowPaymentHistoryItemId, PaymentConfigId, PrincipalModificationId } from '../BrandedIds';
import { zodBrandedUuid, zodDateOrString } from '../utils';

export const PaymentConfigSource = z.enum([
  'initial',
  'escrowMonthlyInsuranceManualUpdate',
  'updateBuydownInterestRate',
  'armUpdate',
  'armManualUpdate',
  'constructionToPermanentEvent',
  'updateDelinquentInterestRate', // Deprecating this
  'manualUpdate',
  'drawRecord',
  'flexModification',
]);

export type PaymentConfigSource = z.infer<typeof PaymentConfigSource>;

export const PaymentConfig = z.object({
  id: zodBrandedUuid<PaymentConfigId>(),
  source: PaymentConfigSource,
  referenceId: zodBrandedUuid<EscrowPaymentHistoryItemId>().optional(),
  createdAt: zodDateOrString,
  effectiveDate: zodDateOrString,
  type: z.enum(['fixed', 'arm']),
  isInterestOnly: z.boolean(),
  /**
   * @deprecated
   * Use getCurrentPrincipalAndInterest as this config item does not contain a full history for loans w/ draws or other interest-changing events
   */
  monthlyPrincipalAndInterestTotal: z.number(), // This should just be called principalAndInterestTotal
  monthlyInterestRate: z.number(), // This should just be called interestRate
  modificationId: zodBrandedUuid<PrincipalModificationId>().optional(),
});
export type PaymentConfig = z.infer<typeof PaymentConfig>;
